module.exports = __webpack_public_path__ + "static/fareed-zakaria-f90e2aa794eaa7425b3d05225950a70c.jpg";